/**
 * Determine whether an event is a keyboard event.
 * @param e Event
 * @returns boolean
 */
export const getIsKeyboardEvent = (e: React.KeyboardEvent<HTMLElement>) => {
    return (
        e.nativeEvent instanceof KeyboardEvent ||
        e.type === 'keydown' ||
        ((e.nativeEvent as PointerEvent).pointerType === '' &&
            ((e.nativeEvent as KeyboardEvent).key === 'Enter' ||
                (e.nativeEvent as KeyboardEvent).key === ' '))
    );
};

/**
 * Determine whether a React.KeyboardEvent is a keyboard select event.
 * Filters for Enter and Space bar keydown events.
 * @param e React.KeyboardEvent<HTMLElement>
 * @returns boolean
 */
export const getIsKeyboardSelect = (e: React.KeyboardEvent<HTMLElement>) => {
    return e.type === 'keydown' && (e.key === 'Enter' || e.key === ' ');
};

export const stringToBoolean = (value: unknown): boolean => {
    return value === 'true';
};

/**
 * Detect whether the current runtime is a local/development client.
 * Returns true only in client contexts (when `window` is available) and
 * when the hostname indicates a local machine or when NODE_ENV is
 * explicitly `development`.
 *
 * This is used to scope local-only URL prefix fixes so they don't run
 * during server-side rendering or in production.
 */
export function isLocalDev() {
    try {
        return (
            typeof window !== 'undefined' &&
            (window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1' ||
                window.location.hostname === '::1' ||
                (window.location.hostname &&
                    window.location.hostname.endsWith('.local')) ||
                process.env.NODE_ENV === 'development')
        );
    } catch {
        return false;
    }
}
